import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';
import { PostMessagePayload } from '@sdk/messages/types/apiTypes';

import { useConversationQueryCache } from '@web/conversations/hooks/useConversationQueryCache';
import { POST_MESSAGE_RETRY } from '@web/conversations/consts/messages';

import { useConversationMappers } from './useConversationMappers';
import { useSoundNotification } from './useSoundNotification';
import { useMessageConfetti } from './useMessageConfetti';

export const usePostMessage = () => {
  const { addMessage } = useConversationQueryCache();
  const { messages } = useSlingApi();
  const { mapAPIMessageStrategy } = useConversationMappers();
  const { messageSent } = useSoundNotification();
  const { tryConfetti } = useMessageConfetti();

  const mutation = useMutation({
    mutationFn: async (payload: PostMessagePayload) => {
      messageSent();
      const result = await messages.post(payload);
      const message = mapAPIMessageStrategy(result.data);

      return message;
    },
    onSuccess: (message) => {
      addMessage(message);
      tryConfetti(message);
    },
    retry: POST_MESSAGE_RETRY,
  });

  return mutation;
};
